import Media from "css/Media";
import React from "react";
import styled from "styled-components";
import WP from "WP";

export function ActivitiesForm() {
  const t = useTranslation(WP.lang);
  const [amountOfChildren, setAmountOfChildren] = React.useState(0);
  const [toFromDates, setToFromDates] = React.useState({
    arrivaldate: new Date().toISOString().slice(0, 10),
    // add 7 days to the current date
    enddate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10),
  });

  return (
    <FormWrapper>
      <div>
        <h3>{t("title", "Aktivitetskalender")}</h3>
        <p>{t("description", "Se tilgjengelighet og bestill flere opplevelser samtidig")}</p>
      </div>

      <Form method="POST" action={t("formAction")} target="_blank">
        <HStack>
          <label htmlFor="arrivaldate">{t("arrivaldate", "Fra og med")}</label>
          <Input
            type="date"
            id="arrivaldate"
            name="arrivaldate"
            value={toFromDates.arrivaldate}
            onChange={(e) => {
              const newArrivalDate = e.target.value;
              if (newArrivalDate > toFromDates.enddate) {
                return setToFromDates({
                  arrivaldate: newArrivalDate,
                  enddate: newArrivalDate,
                });
              }
              setToFromDates({
                ...toFromDates,
                arrivaldate: newArrivalDate,
              });
            }}
          />

          <label htmlFor="enddate">{t("enddate", "Til og med")}</label>
          <Input
            type="date"
            id="enddate"
            name="enddate"
            value={toFromDates.enddate}
            onChange={(e) => {
              setToFromDates({
                ...toFromDates,
                enddate: e.target.value,
              });
            }}
          />

          <HStack>
            <label htmlFor="adults">{t("peopleLabel", "Antall personer")}</label>
            <Select name="adults" id="adults" defaultValue="2">
              <option value="1">1 {t("adult", "Voksen")}</option>
              <option value="2">2 {t("adults", "Voksne")}</option>
              <option value="3">3 {t("adults", "Voksne")}</option>
              <option value="4">4 {t("adults", "Voksne")}</option>
              <option value="5">5 {t("adults", "Voksne")}</option>
              <option value="6">6 {t("adults", "Voksne")}</option>
              <option value="7">7 {t("adults", "Voksne")}</option>
              <option value="8">8 {t("adults", "Voksne")}</option>
            </Select>

            <Select
              name="children"
              id="children"
              value={amountOfChildren}
              onChange={(e) => {
                setAmountOfChildren(parseInt(e.target.value));
              }}
            >
              <option value="0">0 {t("children", "Barn")}</option>
              <option value="1">1 {t("child", "Barn")}</option>
              <option value="2">2 {t("children", "Barn")}</option>
              <option value="3">3 {t("children", "Barn")}</option>
              <option value="4">4 {t("children", "Barn")}</option>
            </Select>
          </HStack>
        </HStack>

        <HStack style={{ justifyContent: "flex-start" }} order={2}>
          <label htmlFor="childage1" style={{ display: amountOfChildren > 0 ? "block" : "none" }}>
            {t("childAge", "Alder på barn")}
          </label>
          <ChildAgeSelect childNumber={1} show={amountOfChildren >= 1} />
          <ChildAgeSelect childNumber={2} show={amountOfChildren >= 2} />
          <ChildAgeSelect childNumber={3} show={amountOfChildren >= 3} />
          <ChildAgeSelect childNumber={4} show={amountOfChildren >= 4} />
        </HStack>

        <Button type="submit">
          {t("", "Søk")} <span style={{ fontSize: "1.4em" }}>🢒</span>
        </Button>
      </Form>
    </FormWrapper>
  );
}

const FormWrapper = styled.div`
  display: flex;
  text-align: left;
  flex-direction: column;
  font-size: 0.75rem;
  gap: 2em;
  background-color: ${(props) => props.theme.colors.bg};
  justify-content: center;
  margin: 2rem 2rem 8rem;
  ${Media.greaterThan("ss")`
    margin: 2rem auto 8rem;
    width: fit-content;
  `}
  padding: 3em 3em 4em 3em;
`;

const Form = styled.form`
  display: grid;
  grid-template-columns: 1fr;

  gap: 1.5em;
  align-items: center;

  ${Media.greaterThan("ss")`
    grid-template-columns: 1fr auto;`}
`;

const Button = styled.button`
  display: flex;
  white-space: nowrap;
  justify-content: space-between;
  text-transform: uppercase;
  align-items: center;
  flex-direction: row;
  border-radius: 0;
  gap: 3em;
  background-color: ${(props) => props.theme.colors.button};
  color: white;
  border: none;
  padding: 0.5em 1em;
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.colors.link};
  }
`;

const Input = styled.input`
  padding: 0.5em;
  border: none;
  box-shadow: none;
  border-radius: 0;
  outline: none;
  position: relative;

  &[type="date"]::-webkit-calendar-picker-indicator {
    background: transparent;
    bottom: 0;
    color: transparent;
    cursor: pointer;
    height: auto;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
  }
`;

const Select = styled.select`
  padding: 0.5em;
  border: none;
  box-shadow: none;
  border-radius: 0;
  background-color: #fff;
  border: 0px solid;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: ${(props) => {
    // Create an SVG arrow icon
    // Use the theme color for the arrow icon
    const color = encodeURIComponent(props.theme.colors.bg);
    const arrowIconSVG = `data:image/svg+xml;utf8,<svg fill='${color}' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>`;
    return `url("${arrowIconSVG}")`;
  }};

  background-repeat: no-repeat;
  background-position: right center;
  padding-right: 2em;
`;

const HStack = styled.div`
  display: flex;
  flex-direction: column;
  ${Media.greaterThan("ss")`
    flex-direction: row;
    justify-content: start;
    align-items: center;
    order: ${(props) => (props.order ? props.order : 0)};
  `};
  flex-wrap: wrap;
  gap: 1em;
  justify-content: center;
`;

const translations = {
  en: {
    formAction: "https://svalbardadventures.travelize24.com/booking-widget",
    title: "Activity Calendar",
    description: "Check availability and book multiple activities at once",
    arrivaldate: "From",
    enddate: "To",
    peopleLabel: "Number of people",
    search: "Search",
    children: "Children",
    child: "Child",
    adults: "Adults",
    adult: "Adult",
    year: "year",
    years: "years",
    childAge: "Age of children",
  },
  no: {
    formAction: "https://svalbardadventures.travelize24.com/bestilling-widget",
    title: "Aktivitetskalender",
    description: "Se tilgjengelighet og bestill flere opplevelser samtidig",
    arrivaldate: "Fra og med",
    enddate: "Til og med",
    peopleLabel: "Antall personer",
    search: "Søk",
    children: "Barn",
    child: "Barn",
    adults: "Voksne",
    adult: "Voksen",
    year: "år",
    years: "år",
    childAge: "Alder på barn",
  },
};

/**
 * A simple translation function that returns a translation for a given key
 * in the specified language. If the translation is not found, it returns the fallback value.
 *
 * @param {string} language - The language code (e.g., 'en', 'no').
 * @returns {function(keyof typeof translations['no'], string): string} - A function that takes a translationKey and a fallbackText value and returns the translated string.
 */
function useTranslation(lang = "no") {
  return function (key, fallback) {
    return translations[lang] && translations[lang][key] ? translations[lang][key] : fallback;
  };
}

const ChildAgeSelect = ({ childNumber, show }) => {
  const t = useTranslation(WP.lang);
  return (
    <Select name={`childage${childNumber}`} style={{ display: show ? "block" : "none" }} id={`childage${childNumber}`}>
      <option value="0">
        {t("child")} {childNumber}, 0 {t("years", "år")}
      </option>
      <option value="1">
        {t("child")} {childNumber}, 1 {t("year", "år")}
      </option>
      <option value="2">
        {t("child")} {childNumber}, 2 {t("years", "år")}
      </option>
      <option value="3">
        {t("child")} {childNumber}, 3 {t("years", "år")}
      </option>
      <option value="4">
        {t("child")} {childNumber}, 4 {t("years", "år")}
      </option>
      <option value="5">
        {t("child")} {childNumber}, 5 {t("years", "år")}
      </option>
      <option value="6">
        {t("child")} {childNumber}, 6 {t("years", "år")}
      </option>
      <option value="7">
        {t("child")} {childNumber}, 7 {t("years", "år")}
      </option>
      <option value="8">
        {t("child")} {childNumber}, 8 {t("years", "år")}
      </option>
      <option value="9">
        {t("child")} {childNumber}, 9 {t("years", "år")}
      </option>
      <option value="10">
        {t("child")} {childNumber}, 10 {t("years", "år")}
      </option>
      <option value="11">
        {t("child")} {childNumber}, 11 {t("years", "år")}
      </option>
      <option value="12">
        {t("child")} {childNumber}, 12 {t("years", "år")}
      </option>
      <option value="13">
        {t("child")} {childNumber}, 13 {t("years", "år")}
      </option>
      <option value="14">
        {t("child")} {childNumber}, 14 {t("years", "år")}
      </option>
      <option value="15">
        {t("child")} {childNumber}, 15 {t("years", "år")}
      </option>
      <option value="16">
        {t("child")} {childNumber}, 16 {t("years", "år")}
      </option>
    </Select>
  );
};
